module.exports = __webpack_public_path__ + "static/media/black-master.733d1053.svg";